export const getBySlug = (arr: any[], slug: string) =>
  arr.find((obj) => obj?.slug === slug);
